<template>
  <RefineComponent
    class="refine-purchasing"
    :element="item"
    subtitle>
    <template #bread>
      <NewPurchBread
        :check-exit="checkChages"
        class="pt-1"/>
    </template>
    <template #step>
      <StepNumber
        all_steps="3"
        step="2"/>
    </template>
    <template #next_step>
      <NextStep
        :name="$t('Catalog.CheckPurchase')"
        step="3"
        @next="nextStep"/>
    </template>
    <template #table>
      <v-skeleton-loader
        v-if="loading"
        :boilerplate="false"
        class=""
        :tile="false"
        type=" table-thead, table-tbody, table-tbody"
        width="100%"/>
      <template v-else>
        <sForm
          ref="refinePurchaseForm"
          :disabled="loading"
          :model="{rows: positions}"
          :rules="refinePurchaseRules">
          <RowsTable
            :change-field="checkValid"
            class="purchase-items"
            :headers="headers"
            :item="item"
            :positions.sync="positions"
            validate-prop-prefix="rows"
            @cancelSelection="cancelSelection"
            @copyItem="copyItem"/>
        </sForm>
      </template>
    </template>
    <template #footer>
      <ComponentFooter
        key="footer"
        :back="previousStep"
        :back_btn="$t('Catalog.ChangePurchase')"
        :loading="loading"
        :next="nextStep"
        next_btn>
        <template #next>
          <router-link :to="{name: 'purchasing', query: {type:'drafts'}, params: {org: $route.params.org}}">
            <sButton
              class="mr-5"
              data-qa="btn-to-drafts"
              :disabled="loading"
              icon="draft"
              :loading="loading"
              :rounded="false"
              type="text"
              @click="saveRows">
              {{ $t('Catalog.ToDrafts') }}
            </sButton>
          </router-link>
        </template>
      </ComponentFooter>
    </template>
  </RefineComponent>
</template>
<script>
import NextStep from 'components/tenders/NextStep.vue'
import RowsTable from 'components/common/blocks/RowsTable.vue'
import RefineComponent from 'pages/templates/RefineComponent.vue'
import StepNumber from 'components/common/elements/StepNumber.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'
import NewPurchBread from 'components/purchasing/new purchase/NewPurchBread.vue'

import { ApplicationRowDraft } from '@/types/application_draft.js'
import ApplicationsApi from '@/api/applicationApi'
const api = new ApplicationsApi()
import { filterSortMixin, applicationMixin, beforeunloadMixin, modalMixin } from 'mixins'

export default {
  name: 'refinePurchase',
  mixins: [ filterSortMixin, applicationMixin, modalMixin ,beforeunloadMixin ],
  data() {
    return {
      //next_available: false,
      correctValue: true,
      item: {},
      active: null,
      positions: [],
      loading: false,
      draft_rows: [],
      refinePurchaseRules: {},
      headers: [
        {text: this.$t('Catalog.Position'), value: 'name', sortable: false, width: '25%', cellClass: 'secondary__green_chosen' },
        {text: this.$t('Tenders.AdditionalDescription'), value: 'description',sortable: false, width: '20%'   },
        {text: this.$t('Catalog.Amount'), value: 'declaredQuantity',sortable: false, width: '12%', required: true },
        {text: this.$t('Catalog.DeliveryDate'), value: 'declaredSupplyDate', sortable: false, width: '16%', required: true  },
        {text: this.$t('Catalog.Price'), value: 'price', sortable: false, width: '12%'  },
        {text: this.$t('Catalog.TotalCost'), value: 'summ', sortable: false, width: '15%', cellClass: 'secondary__green_chosen' },
        {text: '', value: 'menu', sortable: false, width: '1%', cellClass: 'secondary__green_chosen' }
      ],
    }
  },
  props: {
    app: [ Number, String],
    changeStep: Function
  },
  async created() {
    this.loading = true
    this.item = await this.getApp( this.app || +this.$route?.query?.id)

    if ( this.item?.state != 'П' ) {
      this.$router.push( {name: 'purchitem', params: {id: this.item.id,  org: this.$route.params.org}})
    }
    this.setPositios()

    this.loading = false
  },
  methods: {
    templateRules(rowNumber) {
      const prefix = `rows[${rowNumber}]`
      const that = this
      return {
        [`${prefix}.declaredQuantity`]: [
          {
            type: 'number',
            required: true,
            trigger: 'change',
            min: 0.01,
            message: that.$t('Validate.Required')
          },
        ],
        [`${prefix}.declaredPriority.id`]: [
          {
            type: 'string',
            trigger: 'change',
            validator(rule, value, callback) {
              if (!that.positions[rowNumber].declaredSupplyDate && !value) {
                callback(new Error(that.$t('Validate.Required')))
              }
              callback()
            }
          },
        ],
        [`${prefix}.declaredSupplyDate`]: [
          {
            type: 'string',
            trigger: 'change',
            validator(rule, value, callback) {
              if (!that.positions[rowNumber].declaredPriority.id && !value) {
                callback(new Error(that.$t('Validate.Required')))
              }
              if (value && that.$moment(value).format('YYYY-MM-DD') < that.$moment().format('YYYY-MM-DD')) {
                callback(new Error(that.$t('Validate.DateMoreEqualCurrent')))
              }
              callback()
            },
          },
        ],
      }
    },
    createRules() {
      this.refinePurchaseRules = {}
      this.positions.forEach((element, index) => {
        this.refinePurchaseRules = {
          ...this.refinePurchaseRules,
          ...this.templateRules(index),
        }
      })
    },
    checkValid() {
      this.correctValue = true
      if (!this.$refs.refinePurchaseForm) { return }
      this.$refs.refinePurchaseForm.validate((valid) => {
        this.correctValue = valid
      }, true)
    },
    checkChages() {
      let new_rows = this.positions.map(row => new ApplicationRowDraft(row))
      return  this.$_.differenceWith(this.draft_rows, new_rows, this.$_.isEqual)?.length
    },
    setPositios() {
      if (!this.item || !Object.keys(this.item).length) {
        return this.positions =  []
      }

      this.positions = this.item.rows.map((row, index) => ({...row, index: index + 1}))
      this.draft_rows = this.positions.map(row => new ApplicationRowDraft(row))
      this.createRules()
    },
    cancelSelection(item) {
      api.deleteRows( this.item.id, [item.id])
        .then(() => {
          this.positions =  this.positions
            .filter( el =>  el.id != item.id)
            .map((row, index) => ({...row, index: index + 1}))
          this.createRules()
        })
        .catch(error => this.$log_error(error.message))
    },
    async copyItem(item) {
      let res = await api.duplicateRow(this.item.id, item.id)
      this.positions.push({ ...item, id: res.id, index: this.positions.length + 1 })
      this.draft_rows.push( new ApplicationRowDraft( res ))
      this.createRules()
    },
    async nextStep() {
      if (!this.positions?.length) {
        this.$notice.info({
          title: this.$t('Common.PleaseNote'),
          message: this.$t('Validate.minTypeCount', { count: 1, type: this.$tc('Common.position', 1) }),
        })
        return
      }

      this.$refs.refinePurchaseForm.validate(async (valid) => {
        this.loading = true
        this.$root.$emit('showOverlay')
        if (valid) {
          await this.saveRows()
          await this.changeStep(true, this.item)
          this.$store.commit('addApplications', [this.item])
        } else {
          this.loading = false
          this.$notice.info({
            title: this.$t('Common.PleaseNote'),
            message: this.$t('Validate.checkRequiredFelds'),
          })
        }
        this.$root.$emit('closeOverlay')
      })
    },
    async previousStep() {
      if (this.checkChages()) {
        this.$root.$emit('showExitConfirmation', { submitExit: this.submitPrevStep })
      } else {
        await this.submitPrevStep(false)
      }
    },
    async submitPrevStep() {
      await this.saveRows()
      await this.changeStep(false, this.app || +this.$route?.query?.id)
    },
    async saveRows() {
      let rows = this.positions.map( item => {
        let draft = this.draft_rows.find( el => el.rowId == item.id)
        item = new ApplicationRowDraft({...item, date_comment: item.comment, comment: ''})
        let it = draft.editDraft(item)
        delete it?.headerId
        return it
      }).filter(el => el)

      if ( rows?.length ) {
        return await api.changeRowsInDraft({
          rows ,
          headerId: this.item.id
        })
      }
    }
  },
  components: {
    NextStep,
    RowsTable,
    StepNumber,
    NewPurchBread,
    ComponentFooter,
    RefineComponent,
  }
}
</script>
